export default (str) => {
  if (typeof (str) !== 'string') {
    return ''
  }
  return str[0].toUpperCase() + str.substr(1)
}
